import { render, staticRenderFns } from "./CustomerMatchVolunteerDetails.vue?vue&type=template&id=29e12e62"
import script from "./CustomerMatchVolunteerDetails.vue?vue&type=script&lang=ts"
export * from "./CustomerMatchVolunteerDetails.vue?vue&type=script&lang=ts"
import style0 from "./CustomerMatchVolunteerDetails.vue?vue&type=style&index=0&id=29e12e62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports